<section class="main-wrap inner-views dashboard-wrap lens-module" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container single-product lens-module lens-accessories">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">
            <app-product-data [tempCartEvents]="tempCartEventsSubject.asObservable()"></app-product-data>
          </div>
        </div>
        <div class="col-md-6">
          <div class="prod-col-in">
            <h2 class="prod-title">
              Lens Selection
            </h2>
            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 module-accessories">
              <h3>Accessories</h3>
              <p>Please select eyewear accessories below. (Optional)</p>
              <span class="border"></span>
              @if (accessoriesVM.length > 0) {
                <div class="readers-data">
                  @for (l of accessoriesVM; track $index; let i = $index) {
                    <div class="col-md-4 lens-accessory" (click)="toggleCheckbox(i, $event)">
                      <div class="lens-accessory-inner">
                        <img [attr.src]="imgSrc + l.accessoryImage" alt="Product"/>
                        <h3>{{l.accessoryName}}</h3>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input #checkboxRef type="checkbox" [value]="l.accessoryName" [checked]="l.isSelected" (click)="checkBoxClick(i, $event)">
                            <div class="accessory-price">{{l.accessoryPrice | currency}}</div>
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="col-md-12 module-options">
                  <h3>No glasses accessories are provided through your company.</h3>
                </div>
              }
            </div>
            <div class="col-md-12 module-nav single-option">
              <button class="btn product-btn gray-btn" (click)="addToCart()" type="button">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

